export default "<tln-data [routePrefix]=\"routePrefix\"></tln-data>\n"